import { useQuery } from "@tanstack/react-query";
import type { JSX } from "react";
import { useORPC } from "../../orpc-react.tsx";
import { Card } from "../Card.tsx";

export function ServerHealthChecks(): JSX.Element {
  const orpc = useORPC();

  const checks = useQuery({
    ...orpc.health.queryOptions({ input: {} }),
    refetchInterval: 2000,
  });
  const results = checks.data;

  return (
    <>
      <h1>Server Health Checks</h1>
      <p>This page displays the health status of the server.</p>
      {checks.error && <p>{checks.error.message}</p>}
      {checks.isLoading && <p>Getting health check reports...</p>}
      {checks.data &&
        checks.data.map(({ checkedAt, ok, service }) => (
          <Card style={{ width: "100%" }}>
            <h4>{service.name}</h4>
            {ok ? "✔" : "⚠️"}
            {checkedAt && <hr />}
            {checkedAt && (
              <p>
                Last checked at: <span>{checkedAt}</span>
              </p>
            )}
          </Card>
        ))}
    </>
  );
}
